/* eslint-disable */
import React from 'react';
import Select from 'react-select-okjp';
import './CurrencySelect.less';
import RootContext from '_src/common/container/RootContext';
import {RootContextState, RootContextProps} from '_common/container/RootContext';


interface GravatarOptionProps {
  className?: string;
  isFocused?: boolean;
  onFocus: (option: any, event: React.MouseEvent<HTMLDivElement>) => void;
  onSelect: (option: any, event: React.MouseEvent<HTMLDivElement>) => void;
  option: {
    title: string,
    currency: string,
    operationalStatus?: number,
  };
}

class GravatarOption extends React.Component<GravatarOptionProps> {
  static defaultProps = {
    className: '',
    isFocused: false,
    onFocus: () => {},
    onSelect: () => {},
  };

  handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    this.props.onFocus(this.props.option, event);
  };

  handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (this.props.isFocused) {
      return;
    }
    this.props.onFocus(this.props.option, event);
  };

  render() {
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <span className="select-num">{this.props.option.currency}</span>
      </div>
    );
  }
}

interface GravatarValueProps {
  value: {
    title: string,
    currency: string,
  };
}

function GravatarValue({ value }: GravatarValueProps) {
  return (
    <div className="Select-value" title={value.title}>
      <span className="Select-value-label">
        <span className="select-num">{value.currency}</span>
      </span>
    </div>
  );
}

interface CurrencySelectProps extends RootContextProps {
  clearable?: boolean;
  searchable?: boolean;
  disabled?: boolean;
  showPauseTips?: boolean;
  list: Array<{
    title: string,
    currency: string,
    operationalStatus?: number,
  }>;
  selectedObj?: {
    title: string,
    currency: string,
    operationalStatus?: number,
  };
  changeSelectedHandle: (value: any) => void;
  placeholder?: string;
  noResultsText?: string;
}

class CurrencySelect extends RootContext<CurrencySelectProps,{}> {
  static defaultProps = {
    clearable: false,
    searchable: true,
    disabled: false,
  };

  setValue = (value: any) => {
    this.props.changeSelectedHandle(value);
  };

  render() {
    const { showPauseTips, list, selectedObj } = this.props;
    let renderList = list;
    let renderSelectedObj = selectedObj;
    if (showPauseTips === true) {
      renderList = renderList.map((T) => {
        return {
          ...T,
          currency:
            T.operationalStatus === 0
              ? `${T.currency}${this.translate('pause.network')}`
              : T.currency,
        };
      });
      renderSelectedObj =
        renderSelectedObj?.currency !== undefined
          ? {
              ...renderSelectedObj,
              currency:
                renderSelectedObj.operationalStatus === 0 &&
                !renderSelectedObj.currency.includes(
                  this.translate('pause.network')
                )
                  ? `${renderSelectedObj.currency}${this.translate(
                      'pause.network'
                    )}`
                  : renderSelectedObj.currency,
            }
          : renderSelectedObj;
    }
    return (
      <>
        <label className="account-currency-select-label">
          %A_HIDDEN_MOCK_PASSWORD_TITLE_TO_AVOID_AUTOCOMPLETE%
        </label>
        <Select
          onChange={this.setValue}
          optionComponent={GravatarOption}
          options={renderList}
          value={renderSelectedObj}
          valueComponent={GravatarValue}
          clearable={this.props.clearable}
          placeholder={this.props.placeholder}
          searchable={this.props.searchable}
          disabled={this.props.disabled}
          noResultsText={this.props.noResultsText}
        />
      </>
    );
  }
}

export default CurrencySelect;
